export const validateFile = (file) => {
  const validTypes = ['text/comma-separated-values', 'text/csv', 'application/csv'];
  return validTypes.indexOf(file.type) !== -1;
}
